import React from 'react';
import styled from 'styled-components';

export const RatingStarIcon = styled.svg`
    width: 12px;
    height: 12px;

    transition: stroke 0.3s;
`;

export const RatingStar: React.FC<{}> = () => (
    <RatingStarIcon xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' height='100%' width='100%' fill='none'>
        <g id='_starMini'>
            <path
                id='Mini review star full'
                d='M4.29962 4.64733L4.59576 4.61812L4.71131 4.3439L5.99925 1.28741L7.28771 4.34396L7.40333 4.61822L7.69954 4.64734L10.8422 4.95627L8.40696 7.20816L8.19526 7.40392L8.25866 7.6852L8.99715 10.9616L6.2607 9.29985L6.00112 9.14222L5.74157 9.2999L3.02897 10.9478L3.81655 7.69285L3.88655 7.40354L3.6656 7.2041L1.17451 4.95552L4.29962 4.64733Z'
            />
        </g>
    </RatingStarIcon>
);
